import React from 'react'

import { bemJoin } from 'bem-join'

import { useIntl } from '@app/intl/Intl'
import { InfoTooltip } from '@app/lib/display/InfoTooltip/InfoTooltip'
import { TooltipMessage } from '@app/lib/display/TooltipMessage/TooltipMessage'
import { InputField } from '@app/lib/fields/InputField/InputField'
import { AmountInput } from '@app/lib/inputs/TextInput/AmountInput'
import { Text } from '@app/lib/typography/Text/Text'
import { FeeFactorInputField } from '@app/modules/CourtCases/Components/CourtCaseInvoicingForm/Components/InvoicingOwnCostSection/FeeFactorInputField/FeeFactorInputField'
import { VatTotal } from '@app/modules/CourtCases/Components/CourtCaseInvoicingForm/Components/InvoicingOwnCostSection/VatTotal/VatTotal'

export const InvoicingOwnCostSection = () => {
  const b = bemJoin('court-case-invoicing-form')
  const { formatMessage } = useIntl()

  return (
    <div className={b('section')}>
      <Text size={'ml'} weight={'bold'}>
        {formatMessage({ id: 'CourtCases.Invoicing.Section.OwnCosts.Title' })}
      </Text>
      <div className={b('fields')}>
        <FeeFactorInputField fieldName={'ProceduralFee'} />
        <FeeFactorInputField fieldName={'AppointmentFee'} />
        <InputField
          name='Expenses'
          label={
            <InfoTooltip
              message={
                <TooltipMessage
                  heading={formatMessage({ id: 'CourtCases.Invoicing.Field.Expenses' })}
                  text={formatMessage({ id: 'CourtCases.Invoicing.Field.Expenses.Tooltip.Text' })}
                />
              }
            >
              {formatMessage({ id: 'CourtCases.Invoicing.Field.Expenses' })}
            </InfoTooltip>
          }
          rules={{
            pattern: {
              value: /^[0-9]+(\.[0-9])?$/,
              message: formatMessage({ id: 'CourtCases.Invoicing.Field.Error.ValidValue' })
            }
          }}
          render={({ inputProps }) => {
            return (
              <AmountInput
                inputProps={inputProps}
                unit={'€'}
                className={b('field', { md: true })}
              />
            )
          }}
        />
        <InputField
          name='OtherCosts'
          label={
            <InfoTooltip
              message={
                <TooltipMessage
                  heading={formatMessage({ id: 'CourtCases.Invoicing.Field.OtherCosts' })}
                  text={formatMessage({ id: 'CourtCases.Invoicing.Field.OtherCosts.Tooltip.Text' })}
                />
              }
            >
              {formatMessage({ id: 'CourtCases.Invoicing.Field.OtherCosts' })}
            </InfoTooltip>
          }
          rules={{
            pattern: {
              value: /^[0-9]+(\.[0-9])?$/,
              message: formatMessage({ id: 'CourtCases.Invoicing.Field.Error.ValidValue' })
            }
          }}
          render={({ inputProps }) => {
            return (
              <AmountInput
                inputProps={inputProps}
                unit={'€'}
                className={b('field', { md: true })}
              />
            )
          }}
        />
        <FeeFactorInputField fieldName={'SettlementFee'} />
        <VatTotal />
      </div>
    </div>
  )
}
